import { copyObject } from '@/helpers/utilsHelper'

/**
 *
 * @param {object} sensor sensor object
 * @param {object} overriddenParams
 * @param {boolean} overriddenParams.showSensorType show sensor type in title or not
 * @param {string} overriddenParams.titleIfEmpty title if sensor is empty
 * @returns {string} formatted title
 */
export const getDeviceSensorTitle = (sensor, overriddenParams) => {
	if(!sensor || Object.keys(sensor).length === 0) return null

	const params = Object.assign({
		showSensorType: true,
		titleIfEmpty: null,
	}, overriddenParams)

	let title = ''
	if (sensor.name) {
		title += sensor.name
	}
	if (params.showSensorType && sensor.__ao__sensor_type) {
		title += ` (${sensor.__ao__sensor_type.title})`
	}

	return title || params.titleIfEmpty
}

/**
 *
 * @param {object} sensor sensor object
 * @param {object} sensorTypesMap sensorTypes
 * @param {object} overriddenParams
 * @param {boolean} overriddenParams.showSensorType show sensor type in title or not
 * @param {string} overriddenParams.titleIfEmpty title if sensor is empty
 * @returns {string} formatted title
 */
export const getDeviceSensorWithAdditionalAttributes = (sensor, sensorTypesMap, overriddenParams) => {
	if(!sensor || Object.keys(sensor).length === 0) return null

	const params = Object.assign({
		showSensorType: true,
		titleIfEmpty: null,
	}, overriddenParams)

	const copiedSensor = copyObject(sensor)

	const sensorType = sensorTypesMap[copiedSensor.sensor_type]

	if (sensorType) {
		const sensorWithAdditionalAttributes = {
			...copiedSensor,
			__ao__sensor_type: sensorType,
		}

		return {
			...sensorWithAdditionalAttributes,
			__ao__title: getDeviceSensorTitle(sensorWithAdditionalAttributes, params),
		}
	}

	return {
		...copiedSensor,
	}

}
